function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types'; // https://github.com/ScottHamper/Cookies

import cookies from 'cookies-js';
import EBPropTypes from 'js-utils/prop-types';
import moment from 'js-utils/moment';
import NotificationBar from './NotificationBar';
import Link from '../link/Link';
import * as constants from './constants'; // Depending on the quarter, determines the month on which the cookie expires
// i.e. Q3 cookies expires on the 1st of October(10)

var EXPIRATION_MONTHS = {
  1: 4,
  2: 7,
  3: 10,
  4: 1
};

var getExpirationDate = function getExpirationDate() {
  var date = new Date();
  var quarter = moment(date).quarter();
  var expirationMonth = EXPIRATION_MONTHS[quarter];
  var expirationYear = quarter === 4 ? date.getFullYear() + 1 : date.getFullYear(); // Subtract 1 from expirationMonth to return to 0-based months

  var expirationDate = new Date(expirationYear, expirationMonth - 1, 1);
  return expirationDate;
};

var getCookieConfig = function getCookieConfig() {
  return {
    path: '/',
    expires: getExpirationDate()
  };
};

var CookieNotification =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(CookieNotification, _PureComponent);

  function CookieNotification() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, CookieNotification);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(CookieNotification)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "state", {
      isHidden: false
    });

    _defineProperty(_assertThisInitialized(_this), "_handleClose", function () {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose();
      }

      _this._handleSetCookieWithExpiry();
    });

    _defineProperty(_assertThisInitialized(_this), "_handleCallAction", function () {
      var onCallAction = _this.props.onCallAction;

      if (onCallAction) {
        onCallAction();
      }

      _this._handleSetCookieWithExpiry();
    });

    _defineProperty(_assertThisInitialized(_this), "_handleSetCookieWithExpiry", function () {
      var cookieName = _this.props.cookieName;

      if (!cookies.get(cookieName)) {
        cookies.set(cookieName, 'true', getCookieConfig());
      }

      _this.setState({
        isHidden: true
      });
    });

    return _this;
  }

  _createClass(CookieNotification, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          actionText = _this$props.actionText,
          linkText = _this$props.linkText,
          linkHref = _this$props.linkHref,
          message = _this$props.message;
      var isHidden = this.state.isHidden;
      return React.createElement(NotificationBar, {
        hasCloseButton: true,
        isHidden: isHidden,
        type: constants.TYPE_ORBITAL,
        callAction: actionText,
        onCallAction: this._handleCallAction,
        onClose: this._handleClose
      }, React.createElement("span", {
        "data-spec": "cookie-notification-message"
      }, "".concat(message, " ")), React.createElement(Link, {
        "data-spec": "cookie-notification-link",
        to: linkHref
      }, linkText));
    }
  }]);

  return CookieNotification;
}(PureComponent);

_defineProperty(CookieNotification, "propTypes", {
  /**
   * The name of cookie that cookies-js attempts to retrieve
   */
  cookieName: PropTypes.string.isRequired,

  /**
   * The href to help article about cookies
   */
  linkHref: PropTypes.string.isRequired,

  /**
   * The main text that is shown on the cookie notification bar
   */
  message: EBPropTypes.translation.isRequired,

  /**
   * The text on the primary action button
   */
  actionText: EBPropTypes.translation,

  /**
   * Text that will be linked to the help article about cookies
   */
  linkText: EBPropTypes.translation,

  /**
   * Callback for when the user closes the notification
   */
  onClose: PropTypes.func,

  /**
   * Callback for when the user accepts the notification
   */
  onCallAction: PropTypes.func
});

_defineProperty(CookieNotification, "defaultProps", {
  actionText: constants.actionText,
  linkText: constants.linkText
});

export { CookieNotification as default };